import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { TransparentButton } from '../../ClickableComponents/Button';
import { PlayTransparentLink } from '../../ClickableComponents/PlayLink';
import { DialogActionSection } from '../DialogActionSection';
import { DialogContentWrapper } from '../DialogContentWrapper';
import { useDialogDispatch } from '../DialogContext';
import { DialogTextSection } from '../DialogTextSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RtsLoginDialog = () => {
  const {
    t
  } = useTranslation();
  const dispatchPopup = useDialogDispatch();
  return /*#__PURE__*/_jsx(DialogContentWrapper, {
    title: t('personalization.enablePersonalization'),
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(DialogTextSection, {
        title: "Connexion",
        children: /*#__PURE__*/_jsx(TextWrapper, {
          children: /*#__PURE__*/_jsx(Text, {
            children: "Vous devez \xEAtre connect\xE9 pour ajouter ce contenu \xE0 une playlist"
          })
        })
      }), /*#__PURE__*/_jsxs(DialogActionSection, {
        children: [/*#__PURE__*/_jsx(TransparentButton, {
          type: "text",
          text: t('global.cancel'),
          onClick: () => dispatchPopup({
            type: 'remove-dialog'
          })
        }), /*#__PURE__*/_jsx(PlayTransparentLink, {
          to: `https://www.rts.ch/profile/login?redirect=${window.location.href}`,
          fontSize: {
            mediaQuery: [],
            default: 16
          },
          text: "Se connecter",
          onClick: () => {
            dispatchPopup({
              type: 'remove-dialog'
            });
          }
        })]
      })]
    })
  });
};
const TextWrapper = styled.div.withConfig({
  displayName: "RtsLoginDialog__TextWrapper",
  componentId: "sc-162gum0-0"
})(["margin-top:24px;"]);
const Text = styled.span.withConfig({
  displayName: "RtsLoginDialog__Text",
  componentId: "sc-162gum0-1"
})(["white-space:pre-wrap;color:", ";", ";line-height:24px;"], Colors.GREY_d2d2d2, Fonts.regular(16));
const Container = styled.div.withConfig({
  displayName: "RtsLoginDialog__Container",
  componentId: "sc-162gum0-2"
})(["display:flex;flex-direction:column;max-width:382px;"]);